module.exports = __webpack_public_path__ + "img/saasy@2x.4bad4f48.png";